import { PortableText } from '../PortableText';
import React from 'react';
import { MediaTestimonial as RawMediaTestimonial } from '../../../components/landingPage/MediaTestimonial';
import { SanityBlock, SanityObject } from '../../../lib/landingPage';
import { Image, ImageProps } from '../Image';
import { ButtonLink, ButtonLinkProps } from '../Link';
import { Wrapper } from '../Wrapper';

export type AgentProps = {
    name: string;
    jobTitle: string;
    logo?: SanityObject<ImageProps>;
};

export type TestimonialProps = {
    agent: SanityObject<AgentProps>;
    statement: SanityBlock;
};

export type MediaTestimonialProps = {
    title: string;
    subtitle: string;
    caption: SanityBlock;
    link: SanityObject<ButtonLinkProps>;
    testimonial: SanityObject<TestimonialProps>;
    backgroundColor: string;
};

export const MediaTestimonial = Wrapper(
    (p: MediaTestimonialProps): JSX.Element => (
        <RawMediaTestimonial
            title={p.title}
            subtitle={p.subtitle}
            caption={<PortableText value={p.caption} />}
            link={<ButtonLink value={p.link} />}
            statement={<PortableText value={p.testimonial.statement} />}
            name={p.testimonial.agent.name}
            jobTitle={p.testimonial.agent.jobTitle}
            logo={
                p.testimonial.agent.logo && (
                    <Image value={p.testimonial.agent.logo} />
                )
            }
            color={p.backgroundColor}
        />
    ),
    'mediaTestimonial'
);
